
(function () {
  if (window.MPNativeCartGiftSync) return;

  var configEl = document.getElementById('mp-native-cart-config');
  var config = { autoGifts: [] };
  try {
    if (configEl && configEl.textContent) config = JSON.parse(configEl.textContent);
  } catch (error) {
    console.warn('[MuffaPro Native Cart] Invalid config', error);
  }

  if (!config.autoGifts || !config.autoGifts.length) return;

  var state = {
    syncing: false,
    lastSignature: '',
    rewardInitialized: false,
    rewardStatus: {}
  };

  function normalizeId(value) {
    if (value === null || value === undefined) return '';
    return String(value).replace('gid://shopify/ProductVariant/', '');
  }

  function money(cents) {
    try {
      return new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format((Number(cents) || 0) / 100);
    } catch (_) {
      return '€' + (((Number(cents) || 0) / 100).toFixed(2)).replace('.', ',');
    }
  }

  function giftForVariant(variantId) {
    var normalized = normalizeId(variantId);
    return config.autoGifts.find(function (gift) {
      return normalizeId(gift.variantId) === normalized;
    });
  }

  function isAutoGiftItem(item) {
    return !!(item && item.properties && String(item.properties._mp_auto_gift) === 'true');
  }

  function eligibleSubtotalCents(cart) {
    return (cart.items || []).reduce(function (sum, item) {
      if (isAutoGiftItem(item)) return sum;
      return sum + (Number(item.final_line_price) || 0);
    }, 0);
  }

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (response) {
      if (!response.ok) throw new Error('cart.js ' + response.status);
      return response.json();
    });
  }

  function addGift(gift) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{
          id: normalizeId(gift.variantId),
          quantity: 1,
          properties: {
            _mp_auto_gift: 'true',
            _mp_auto_gift_threshold: String(gift.thresholdCents || ''),
            _mp_auto_gift_source: 'native_cart'
          }
        }]
      })
    }).then(function (response) {
      if (!response.ok) throw new Error('cart/add.js ' + response.status);
      capture('Cart Gift Auto Added', gift);
      return response.json();
    });
  }

  function changeLine(key, quantity, gift) {
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (response) {
      if (!response.ok) throw new Error('cart/change.js ' + response.status);
      capture(quantity === 0 ? 'Cart Gift Auto Removed' : 'Cart Gift Quantity Corrected', gift);
      return response.json();
    });
  }

  function capture(eventName, gift) {
    try {
      if (window.posthog && typeof window.posthog.capture === 'function') {
        window.posthog.capture(eventName, {
          source: 'shopify_theme_draft_native_cart',
          product_handle: gift.productHandle,
          product_title: gift.productTitle,
          variant_id: normalizeId(gift.variantId),
          threshold: (Number(gift.thresholdCents) || 0) / 100
        });
      }
    } catch (_) {}
  }

  function rewardId(reward) {
    return String(reward.id || reward.productHandle || reward.variantId || reward.thresholdCents || 'reward');
  }

  function rewardThresholds() {
    var configured = Array.isArray(config.rewardThresholds) ? config.rewardThresholds.slice() : [];
    var gifts = (config.autoGifts || []).map(function (gift) {
      return {
        id: 'gift-' + normalizeId(gift.variantId),
        label: gift.productTitle || 'Regalo sbloccato',
        thresholdCents: gift.thresholdCents,
        type: 'gift',
        productHandle: gift.productHandle,
        variantId: gift.variantId
      };
    });
    return configured.concat(gifts);
  }

  function ensureConfettiStyles() {
    if (document.getElementById('mp-cart-confetti-styles')) return;
    var style = document.createElement('style');
    style.id = 'mp-cart-confetti-styles';
    style.textContent = `
      .mp-cart-confetti-layer{position:fixed;inset:0;pointer-events:none;z-index:2147483000;overflow:hidden;}
      .mp-cart-confetti-piece{position:absolute;top:var(--mp-start-y);left:var(--mp-start-x);width:.7rem;height:1.05rem;border-radius:.2rem;background:var(--mp-color);opacity:0;transform:translate3d(0,0,0) rotate(0deg);animation:mpCartConfettiFly 980ms cubic-bezier(.16,1,.3,1) forwards;}
      @keyframes mpCartConfettiFly{0%{opacity:1;transform:translate3d(0,0,0) rotate(0deg) scale(1);}100%{opacity:0;transform:translate3d(var(--mp-x),var(--mp-y),0) rotate(var(--mp-rotate)) scale(.82);}}
      @media (prefers-reduced-motion: reduce){.mp-cart-confetti-piece{animation:none;display:none;}}
    `;
    document.head.appendChild(style);
  }

  function confettiOrigin() {
    var target = document.querySelector('cart-drawer.active .cart-progress.cart-checkpoints, cart-drawer.active .cart-drawer-gift, .cart-progress.cart-checkpoints');
    if (target && target.getBoundingClientRect) {
      var rect = target.getBoundingClientRect();
      return {
        x: rect.left + rect.width / 2,
        y: Math.max(72, rect.top + Math.min(rect.height * 0.45, 80))
      };
    }
    return { x: window.innerWidth - Math.min(260, window.innerWidth * 0.35), y: 120 };
  }

  function burstConfetti(label) {
    try {
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      ensureConfettiStyles();
      var origin = confettiOrigin();
      var layer = document.createElement('div');
      var colors = ['#ff8000', '#ffb000', '#ffd166', '#1f9d8a', '#f25c7a', '#ffffff'];
      layer.className = 'mp-cart-confetti-layer';
      layer.setAttribute('aria-hidden', 'true');
      for (var i = 0; i < 30; i += 1) {
        var piece = document.createElement('span');
        var angle = (Math.PI * 2 * i / 30) + (Math.random() * 0.45);
        var distance = 80 + Math.random() * 190;
        var x = Math.cos(angle) * distance;
        var y = Math.sin(angle) * distance - (45 + Math.random() * 110);
        piece.className = 'mp-cart-confetti-piece';
        piece.style.setProperty('--mp-start-x', origin.x + 'px');
        piece.style.setProperty('--mp-start-y', origin.y + 'px');
        piece.style.setProperty('--mp-x', x.toFixed(1) + 'px');
        piece.style.setProperty('--mp-y', y.toFixed(1) + 'px');
        piece.style.setProperty('--mp-rotate', ((Math.random() * 520) - 260).toFixed(0) + 'deg');
        piece.style.setProperty('--mp-color', colors[i % colors.length]);
        piece.style.animationDelay = (Math.random() * 120).toFixed(0) + 'ms';
        layer.appendChild(piece);
      }
      document.body.appendChild(layer);
      window.setTimeout(function () { layer.remove(); }, 1400);
    } catch (_) {}
  }

  function captureReward(reward, subtotal) {
    var payload = {
      source: 'shopify_theme_draft_native_cart',
      reward_id: rewardId(reward),
      reward_label: reward.label || null,
      reward_type: reward.type || null,
      threshold: (Number(reward.thresholdCents) || 0) / 100,
      cart_subtotal: (Number(subtotal) || 0) / 100
    };
    try {
      if (window.posthog && typeof window.posthog.capture === 'function') {
        window.posthog.capture('Cart Reward Unlocked', payload);
      }
    } catch (_) {}
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: 'cart_reward_unlocked' }, payload));
    } catch (_) {}
  }

  function checkRewardThresholds(cart, subtotal) {
    rewardThresholds().forEach(function (reward) {
      var threshold = Number(reward.thresholdCents) || 0;
      if (!threshold) return;
      var key = rewardId(reward);
      var reached = subtotal >= threshold;
      var wasReached = state.rewardStatus[key] === true;
      if (state.rewardInitialized && reached && !wasReached) {
        burstConfetti(reward.label || 'Regalo sbloccato');
        captureReward(reward, subtotal);
        try {
          document.dispatchEvent(new CustomEvent('mp:cart-reward-unlocked', {
            detail: { id: key, label: reward.label || null, thresholdCents: threshold }
          }));
        } catch (_) {}
      }
      state.rewardStatus[key] = reached;
    });
    state.rewardInitialized = true;
  }

  function refreshCartSections(keepOpen) {
    var sections = ['cart-drawer', 'cart-icon-bubble'];
    var path = window.location.pathname || '/';
    return fetch(path + '?sections=' + sections.join(','), { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('sections ' + response.status);
        return response.json();
      })
      .then(function (htmlBySection) {
        if (htmlBySection['cart-drawer']) {
          var doc = new DOMParser().parseFromString(htmlBySection['cart-drawer'], 'text/html');
          var incoming = doc.querySelector('cart-drawer');
          var current = document.querySelector('cart-drawer');
          if (incoming && current) {
            current.replaceWith(incoming);
            if (keepOpen) {
              var newDrawer = document.querySelector('cart-drawer');
              if (newDrawer) {
                if (typeof newDrawer.open === 'function') newDrawer.open();
                newDrawer.classList.add('active');
                document.body.classList.add('overflow-hidden');
              }
            }
          }
        }
        if (htmlBySection['cart-icon-bubble']) {
          var bubbleDoc = new DOMParser().parseFromString(htmlBySection['cart-icon-bubble'], 'text/html');
          var incomingBubble = bubbleDoc.body.firstElementChild;
          var currentBubble = document.getElementById('cart-icon-bubble') || document.querySelector('[id*="cart-icon-bubble"]');
          if (incomingBubble && currentBubble) currentBubble.replaceWith(incomingBubble);
        }
      })
      .catch(function () {
        window.location.reload();
      });
  }

  function sync(reason) {
    if (state.syncing) return Promise.resolve(false);
    state.syncing = true;

    return getCart().then(function (cart) {
      var subtotal = eligibleSubtotalCents(cart);
      checkRewardThresholds(cart, subtotal);
      var operations = [];
      var signatureParts = [subtotal];

      config.autoGifts.forEach(function (gift) {
        var threshold = Number(gift.thresholdCents) || 0;
        var eligible = subtotal >= threshold;
        var giftLines = (cart.items || []).filter(function (item) {
          return isAutoGiftItem(item) && giftForVariant(item.variant_id) && normalizeId(item.variant_id) === normalizeId(gift.variantId);
        });

        signatureParts.push(normalizeId(gift.variantId) + ':' + eligible + ':' + giftLines.map(function (line) { return line.key + 'x' + line.quantity; }).join('|'));

        if (eligible && giftLines.length === 0) {
          operations.push(function () { return addGift(gift); });
        }

        if (eligible && giftLines.length > 0) {
          giftLines.slice(1).forEach(function (line) {
            operations.push(function () { return changeLine(line.key, 0, gift); });
          });
          if (giftLines[0].quantity !== 1) {
            operations.push(function () { return changeLine(giftLines[0].key, 1, gift); });
          }
        }

        if (!eligible && gift.autoRemove !== false && giftLines.length > 0) {
          giftLines.forEach(function (line) {
            operations.push(function () { return changeLine(line.key, 0, gift); });
          });
        }
      });

      var signature = signatureParts.join('||');
      if (!operations.length || signature === state.lastSignature) return false;
      state.lastSignature = signature;

      return operations.reduce(function (promise, operation) {
        return promise.then(operation);
      }, Promise.resolve()).then(function () {
        return refreshCartSections(reason === 'drawer_open' || document.querySelector('cart-drawer.active'));
      }).then(function () { return true; });
    }).catch(function (error) {
      console.warn('[MuffaPro Native Cart] Gift sync failed', error);
      return false;
    }).finally(function () {
      state.syncing = false;
    });
  }



  function ajaxAddForm(form) {
    if (!form || form.dataset.mpAjaxAdding === 'true') return Promise.resolve(false);

    form.dataset.mpAjaxAdding = 'true';
    var submitButton = form.querySelector('button[type="submit"], button[name="add"], .upsell__add-btn');
    if (submitButton) {
      submitButton.dataset.mpOriginalDisabled = submitButton.disabled ? 'true' : 'false';
      submitButton.disabled = true;
      submitButton.setAttribute('aria-busy', 'true');
    }

    var formData = new FormData(form);
    if (!formData.get('quantity')) formData.set('quantity', '1');

    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' },
      body: formData
    }).then(function (response) {
      if (!response.ok) throw new Error('drawer cart/add.js ' + response.status);
      return response.json();
    }).then(function (data) {
      try {
        if (window.posthog && typeof window.posthog.capture === 'function') {
          window.posthog.capture('Cart Upsell Added', {
            source: 'shopify_theme_draft_native_cart',
            form_id: form.getAttribute('id') || null,
            variant_id: formData.get('id') || null,
            quantity: Number(formData.get('quantity') || 1)
          });
        }
      } catch (_) {}
      return sync('drawer_upsell_added').then(function () {
        return refreshCartSections(true);
      }).then(function () {
        return data;
      });
    }).catch(function (error) {
      console.warn('[MuffaPro Native Cart] Drawer AJAX add failed', error);
      throw error;
    }).finally(function () {
      delete form.dataset.mpAjaxAdding;
      if (submitButton) {
        if (submitButton.dataset.mpOriginalDisabled !== 'true') submitButton.disabled = false;
        submitButton.removeAttribute('aria-busy');
        delete submitButton.dataset.mpOriginalDisabled;
      }
    });
  }

  function schedule(reason, delay) {
    window.clearTimeout(window.__mpNativeCartGiftTimer);
    window.__mpNativeCartGiftTimer = window.setTimeout(function () { sync(reason); }, delay || 700);
  }

  document.addEventListener('DOMContentLoaded', function () { schedule('load', 500); });
  window.addEventListener('pageshow', function () { schedule('pageshow', 500); });

  function drawerAddFormFromEvent(event) {
    var target = event.target;
    if (!target || !target.closest) return null;
    var button = target.closest('button[type="submit"], button[name="add"], .upsell__add-btn');
    if (!button) return null;
    var form = button.closest('form[action*="/cart/add"]');
    if (!form || !form.closest('cart-drawer')) return null;
    return form;
  }

  function interceptDrawerAdd(event) {
    var form = drawerAddFormFromEvent(event);
    if (!form) return;
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    ajaxAddForm(form);
  }

  function interceptDrawerSubmit(event) {
    var form = event.target;
    if (!form || !form.matches || !form.closest('cart-drawer') || !form.matches('form[action*="/cart/add"]')) return;
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    ajaxAddForm(form);
  }

  // Use window capture so this runs before the theme's own document/button handlers.
  window.addEventListener('click', interceptDrawerAdd, true);
  window.addEventListener('submit', interceptDrawerSubmit, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches) return;
    if (form.matches('form[action*="/cart/add"], form[action*="/cart"]')) schedule('form_submit', 1400);
  }, true);

  document.addEventListener('click', function (event) {
    var target = event.target && event.target.closest && event.target.closest('button[name="add"], [type="submit"], .cart__checkout-button, .quantity__button, cart-remove-button');
    if (target && !drawerAddFormFromEvent(event)) schedule('cart_click', 1200);
  }, true);

  var observer = new MutationObserver(function () {
    var drawer = document.querySelector('cart-drawer.active, cart-drawer[open], cart-drawer.is-open');
    if (drawer) schedule('drawer_open', 400);
  });
  observer.observe(document.documentElement, { attributes: true, childList: true, subtree: true });

  window.MPNativeCartGiftSync = { sync: sync, config: config };
})();
